<script lang="ts" setup>
defineProps({
  hasHeader: {
    default: true,
    type: Boolean,
  },
  maxHeight: {
    default: '',
    type: String,
  },
  scrollable: {
    default: true,
    type: Boolean,
  },
  stringToCopy: {
    default: '',
    type: [
      Array,
      Object,
      String,
    ],
  },
  title: {
    default: '',
    type: String,
  },
})

const rootRef = ref<HTMLDivElement>()

function resetScrollPosition() {
  if (import.meta.client) {
    const apiBoxBody = rootRef.value?.querySelector('.js-api-box-body')

    if (apiBoxBody) {
      apiBoxBody.scrollTo({
        behavior: 'smooth',
        left: 0,
        top: 0,
      })
    }
  }
}

defineExpose({ resetScrollPosition })
</script>

<template>
  <div
    ref="rootRef"
    class="bg-texture shadow-texture group flex flex-col rounded-lg text-gray-900 ring-1 ring-gray-200 dark:text-gray-100 dark:ring-gray-800"
    :class="{ 'overflow-hidden': scrollable }"
  >
    <div
      v-if="title && hasHeader"
      class="flex flex-initial select-none items-center border-b border-gray-200 px-4 dark:border-gray-800"
      :class="{
        'py-2': stringToCopy,
        'py-3': !stringToCopy,
      }"
    >
      <div class="flex flex-1 items-center text-xs uppercase">
        <UIcon
          class="-mt-0.5 mr-1.5 size-5 text-gray-700 dark:text-gray-300"
          :name="getIcon('code')"
        />

        {{ title }}
      </div>

      <ButtonClipboard
        v-if="stringToCopy"
        class="-mr-1.5 ml-1.5 flex-initial"
        size="2xs"
        :string-to-copy="stringToCopy"
      />
    </div>

    <div
      class="js-api-box-body bg-texture flex flex-1 flex-col p-2.5 text-base"
      :class="{ 'overflow-y-auto': scrollable }"
      :style="{ maxHeight: maxHeight || undefined }"
    >
      <div class="relative flex flex-1 flex-col gap-4 p-1.5">
        <ButtonClipboard
          v-if="stringToCopy && !hasHeader"
          class="absolute right-0 top-0 z-10 opacity-0 transition group-hover:opacity-100"
          size="2xs"
          :string-to-copy="stringToCopy"
        />

        <slot />
      </div>
    </div>
  </div>
</template>
